'use strict';

var ClusteringParametersDirective = function ClusteringParametersDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/clustering-parameters.html'),
    requires: '^rmNewCalendar',
    scope: false
  };
};
ClusteringParametersDirective.$inject = [];
module.exports = ClusteringParametersDirective;